// extracted by mini-css-extract-plugin
export default {"AnswerExplanation":"answerExplanation_AnswerExplanation__BqVhW","spinner-frame":"answerExplanation_spinner-frame__of5KL","content":"answerExplanation_content__nMbLm"};